import { Button } from 'antd';
import styled from 'styled-components';
export const DropdownLabel = styled(Button) `
  &&& {
    align-items: center;
    display: flex;
    justify-content: space-between;
    padding: 0 0.6rem;
    width: 300px;

    :hover:enabled,
    :active:enabled,
    :focus:enabled {
      color: rgba(0, 0, 0, 0.65);
    }
  }
`;
